"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getWaveHomeRoute, getWaveRoute } from "@/helpers/navigation.helpers";

/**
 * Hook to manage the active wave ID state and synchronize it with the URL.
 * We rely on the `wave` query param as the single source of truth.
 */
export function useActiveWaveManager() {
  const $ = _c(8);
  const router = useRouter();
  const searchParams = useSearchParams();
  const {
    isApp
  } = useDeviceInfo();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams?.get("wave");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const waveId = t0;
  const activeWaveId = typeof waveId === "string" ? waveId : null;
  let t1;
  if ($[2] !== isApp || $[3] !== router) {
    t1 = (waveId_0, options) => {
      const isDirectMessage = options?.isDirectMessage ?? false;
      const target = waveId_0 ? getWaveRoute({
        waveId: waveId_0,
        isDirectMessage,
        isApp
      }) : getWaveHomeRoute({
        isDirectMessage,
        isApp
      });
      router.push(target);
    };
    $[2] = isApp;
    $[3] = router;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const setActiveWave = t1;
  let t2;
  if ($[5] !== activeWaveId || $[6] !== setActiveWave) {
    t2 = {
      activeWaveId,
      setActiveWave
    };
    $[5] = activeWaveId;
    $[6] = setActiveWave;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}